import PropTypes from "prop-types"

const ItemNameValueShape = {
  value: PropTypes.number.isRequired,
  itemName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
export default ItemNameValueShape



// WEBPACK FOOTER //
// ./src/state/shapes/ItemNameValueShape.js